import { orderBy } from 'lodash';
import { useQuery } from 'react-query';

import { getStoredXerFileVersions as queryFn } from 'api/endPoints/getStoredXerFileVersions';

import { IProgramVersion } from 'components/common/VersionCompareSelectorSection/VersionCompareSelectorWrapper/VersionCompareSelectorWrapper';

export const useQueryGetProjectVersions = (params: QueryParams) => {
    return useQuery<IProgramVersion[], QueryError>({
        queryKey: ['getProjectVersions', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.projectId),
        placeholderData: [],
        select: (data) => {
            return orderBy(data, ['uploadedDate'], ['desc']);
        },
    });
};

export interface QueryParams {
    projectId?: number | null;
    contractId?: number | null;
}
